import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {UserDetailsModel} from '../../../../constants/userModel';
import {ApiService} from '../../../../services/api.service';
import {ErrorService} from '../../../../shared/error-page/service/error-service';
import {Constants} from '../../../../constants/ebtq-constants';
import {TransactionWrapper} from '../../../../model/transactionWrapper';
import {Router} from '@angular/router';
import {UtilityService} from '../../../../services/utility-service';
import {Observable} from 'rxjs';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-servicetransfer',
  templateUrl: './servicetransfer.component.html',
  styleUrls: ['./servicetransfer.component.scss']
})
export class ServicetransferComponent implements OnInit {
  successMess: boolean;
  noLoanData = false;
  loanNumber: string;
  loanSuccess:boolean;
  loanSuccessMsg:string;
  validateMsg:string;

  oldServicerNumber:string;
  newServicerNumber: string;
  loanDetailsArray:any[];
  currentProcessingDate: string;
  effectiveDate: Date;
  effDate: string;
  containsError = false;
  errorMsg: string;
  payoffAmount: string;
  showErrorDiv = false;
  errHeading: string;
  errorMessage: any[];
  userDetails: UserDetailsModel;
  transAmount: number;
  mainPage: string;
  partialIndicatorArray: any[];
  partialIndicatorType = '4';
  utilService: UtilityService;
  transactionWrapper: TransactionWrapper;
  today:any;
  firstDayMonth:any;
  serNumber:any[];
  isExternal:boolean;
  title = 'Servicer Transfer';

  constructor(private apiService: ApiService, private router: Router, private routerCore: Router,
          private errorService: ErrorService, private titleService: Title, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.utilService = new UtilityService();
    this.successMess = false;
    this.errHeading = Constants.ERROR_HEADER;
    this.errorMessage = [];
    this.userDetails = Constants.USER_DETAILS;
    this.partialIndicatorArray = [];
    this.partialIndicatorArray.push({ label: 'PARTIAL', value: '4' });
    this.partialIndicatorArray.push({ label: 'ALL', value: '1' });
    this.partialIndicatorArray.push({ label: 'ALL HECM', value: '2' });
    this.partialIndicatorArray.push({ label: 'ALL HKM', value: '3' });
    this.serNumber = [];

    this.isExternal = JSON.parse(sessionStorage.getItem('isExternal'));
    if (this.isExternal && sessionStorage.getItem('authServrList') != null) {
      this.serNumber = Array.from(JSON.parse(sessionStorage.getItem('authServrList')));
      this.oldServicerNumber = this.serNumber[0].value;
    }

    this.apiService.getCurrentProcessingDate().subscribe(
      (data: any) => {
        this.currentProcessingDate = this.utilService.convertMillisecToDate(data.date);
        this.today = this.currentProcessingDate;
        this.firstDayMonth = this.utilService.getFirstDayOfMonth(this.currentProcessingDate);
        this.cdr.detectChanges();
      },
      error => {

      }
    );

  }

  //Get the loans for given servicing numbers
  serviceTransferSubmit() {
    console.log('servicer transfer submit');
    this.noLoanData = false;
    this.loanSuccess = false;
    if (this.validate())
    {
      this.doesServicerNumberExistObservable(this.oldServicerNumber).subscribe(data=>{
        console.log('resp1', data);
        if (!data.object)
        {
          this.errorMessage.push('016A - Transferor Servicer Number must be a valid servicer number.');
        }

        this.doesServicerNumberExistObservable(this.newServicerNumber).subscribe(data1=>{
          console.log('resp2', data1);
          if (!data1.object)
          {
            this.errorMessage.push('018A - Transferee Servicer Number must be a valid servicer number.');
          }
          if (this.errorMessage.length === 0)
          {

            this.transactionWrapper = new TransactionWrapper();
            this.transactionWrapper.queryServiceName = Constants.SERVICER_TRANSFER_GET_LIST;
            this.transactionWrapper.parameters[0] = this.oldServicerNumber;
            this.transactionWrapper.parameters[1] = this.getProductCode();
            console.log('query:',  this.transactionWrapper.parameters[0] );
            this.apiService.executeQuery(this.transactionWrapper).subscribe(data=>{
              console.log('data', data);
              if ((<any>data).object.length > 0) {
                this.successMess = true;
                this.loanDetailsArray = (<any>data).object;
              }
              else {
                this.noLoanData = true;

              }
              this.cdr.detectChanges();
            },
            error=>{
              this.errorService.announceError(error);
            });
      
            // error announcement
            this.errorAnnouncement();
          }
          this.cdr.detectChanges();
        });

      });

    }

  }

  errorAnnouncement() {
    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  getProductCode()
  {
    
    let allHECM;
    let allHKM;
    let productCode;
    this.partialIndicatorArray.filter(elem=> elem.label === 'ALL HECM')
      .forEach(elem=> allHECM = elem.value);
    this.partialIndicatorArray.filter(elem=> elem.label === 'ALL HKM')
      .forEach(elem=> allHKM = elem.value);
    if (this.partialIndicatorType === allHECM)
    {
      this.utilService.productCode.filter(elem=> elem.label === 'HECM')
        .forEach(elem=> productCode = elem.value);
      return productCode;
    }
    else if (this.partialIndicatorType === allHKM)
    {
      this.utilService.productCode.filter(elem=> elem.label === 'HKM')
        .forEach(elem=> productCode = elem.value);
      return productCode;
    }

  }

  validate() {

    // ======================================================
    // No loan number validation for Servicer Xfer.
    // ======================================================
    this.errorMessage = [];

    if (this.oldServicerNumber === undefined)
    {
      this.errorMessage.push('002B - Servicer Number must be 9 digits');
    }
    if (this.oldServicerNumber != null && (isNaN(Number(this.oldServicerNumber)) || this.oldServicerNumber.length !== 9))
    {
      this.errorMessage.push('002B - Servicer Number must be 9 digits');
    }
    else  if (this.oldServicerNumber != null && (isNaN(Number(this.oldServicerNumber)) ))
    {
      this.errorMessage.push('016A - Transferor Servicer Number must be a valid servicer number.');
    }
    else if (!this.utilService.isUserAuthorizedForServicerNumber(this.oldServicerNumber))
    {
      this.errorMessage.push(
        '050A - User not authorized for servicer( ' + this.oldServicerNumber + ' ).');
    }

    if (this.newServicerNumber === undefined)
    {
      this.errorMessage.push('018A - Transferee Servicer Number must be a valid servicer number.');

    }

    if (this.newServicerNumber != null && (isNaN(Number(this.newServicerNumber)) || this.newServicerNumber.length !== 9))
    {
      this.errorMessage.push('018A - Transferee Servicer Number must be a valid servicer number.');
    }


    //Validations For Effective Date
    if (this.effectiveDate == null )
    {
      this.errorMessage.push('004D - Effective Date is a required field.');
    }
    else if (this.effectiveDate.getTime() < new Date(this.today).getTime())
    {
      this.errorMessage.push('004R - Effective Date must be greater than current date.');

    }

    if (this.effectiveDate != null  && this.effectiveDate.getDate() !== 1)
    {
      this.errorMessage.push('004C - Effective Date must be the first calendar day of the month.');
    }


    if (this.errorMessage.length > 0)
    {
      return false;
    }
    return true;
  }

  clearBtn()
  {
    this.oldServicerNumber = '';
    this.newServicerNumber = '';
    this.effectiveDate = null;
    this.partialIndicatorType = '4';
  }

  //To Validate the given servicer number is exist or not
  doesServicerNumberExistObservable(servicerNumber):Observable<any>
  {
    this.transactionWrapper = new TransactionWrapper();
    this.transactionWrapper.queryServiceName = Constants.GET_SELLER_SERVICER_INFO;
    this.transactionWrapper.parameters[0] = servicerNumber;
    return this.apiService.executeQuery(this.transactionWrapper);
  }


  //Call from child loan submit to parent to proceed with success messages
  loanSubmitCall(event) {
    console.log('event', event);

    this.successMess = false;

    if (event[0] === 'errorMessages') {
      this.errorMessage = event[1];
    } else {
      this.loanSuccess = true;
      this.validateMsg = '031H,Submitted Tran-ActionTypeCode(124)=\'SERVICING TRANSFER\' $0.00 - Please contact your customer representative at Fannie Mae. This transaction will not be processed unless approved.';
      this.loanSuccessMsg = 'Servicer Transfer Transaction successfully submitted ' +
        event[1].length + ' loans from Servicer No. '
        + this.oldServicerNumber + ' to servicer No. ' + this.newServicerNumber
        + ' for Portfolio Type Code: ' + this.partialIndicatorType;
    }

  }

  // Method for on key enter submit
  trackKeyPress(e) {
    //console.log("KEY CODE  ",e.keyCode);
    if (e.keyCode === 13)
    {this.serviceTransferSubmit();}
  }

}
